import { type Dimensions } from '../../types/dimensions';
import { type QuantitativeSize } from '../../types/sizes';
import { parseQuantitativeSize } from '../../util/sizes';

import * as constants from './constants';
import * as types from './types';

export const getAvatarAspectRatio = (
  size: types.AvatarSize,
  resolutionSize?: QuantitativeSize<'px'>,
): Dimensions<number> => {
  if (types.avatarSizeIsResponsive(size)) {
    if (resolutionSize) {
      const [parsed] = parseQuantitativeSize(resolutionSize);
      return { height: parsed, width: parsed };
    }
    return {
      height: constants.AvatarSizeProperties[constants.DefaultAvatarDiscreteSize].size,
      width: constants.AvatarSizeProperties[constants.DefaultAvatarDiscreteSize].size,
    };
  }
  const parsed = constants.getAvatarSize(size);
  return { height: parsed, width: parsed };
};
